import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import customFieldsByGroup from 'modules/custom_resources/store/collections/customFields/byGroup'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'

export interface IResourceField {
  [key: string]: any
}

export interface RawChoiceOption {
  id: string
  label: string
  value: string
  is_active: boolean
}

class ResourceField extends Model<IResourceField> {
  constructor(attr: IResourceField = {}) {
    super(attr)
    makeObservable(this, {
      field: computed,
      isInstalled: computed,
    })
  }

  // FIXME: model should not be coupled to collections
  url() {
    const dynamicPath = (this.collection as any).dynamicPath

    return `${dynamicPath}/${this.attributes.id}`
  }

  get field(): CustomField | null | undefined {
    return customFieldsByGroup.find({
      id: this.attributes.field_id,
    })
  }

  get choiceOptions(): RawChoiceOption[] | undefined {
    return this.attributes.choice_options
  }

  get isInstalled(): boolean {
    return this.attributes.installed
  }
}

export default ResourceField
